<template>
  <section id="contact" class="contact section-show">
    <div class="container">
      <div class="section-title">
        <h2>اطلاعات مالی شما</h2>
      </div>
      <form method="post" class="email-form mt-4" @submit="checkForm">
        <div class="row">
          <div class="col-md-6 form-group">
            <label class="label">نام بانک <img :src="star" /></label>
            <Select2
              id="bankname"
              class="select-form"
              v-model="financial.bankID"
              :options="banks"
              :settings="{ width: '100%' }"
              @select="changeBankItem($event)"
              placeholder="لطفا انتخاب کنید"
            />
            <p class="error" v-if="this.errors.bankname">
              <b>لطفا نام بانک راانتخاب کنید</b>
            </p>
            <label class="label">کدشعبه بانک</label>
            <input
              type="text"
              class="form-control"
              v-model="financial.branchCode"
              @keypress="validateNumber"
            />
            <label class="label">شماره حساب بانکی <img :src="star" /></label>
            <input
              id="BankAccountNumber"
              class="form-control accountnumber"
              type="text"
              v-model="financial.bankAccountNumber"
              @keypress="validateNumber"
            />
            <p class="error" v-if="this.errors.BankAccountNumber">
              <b>لطفا شماره حساب بانکی را وارد کنید</b>
            </p>
          </div>
          <div class="col-md-6 form-group mt-3 mt-md-0">
            <label class="label">نام صاحب حساب <img :src="star" /></label>
            <input
              id="BankAccountOwnerName"
              class="form-control"
              type="text"
              v-model="financial.bankAccountOwnerName"
            />
            <p class="error" v-if="this.errors.BankAccountOwnerName">
              <b>لطفا نام صاحب حساب را وارد کنید</b>
            </p>
            <p class="error" v-if="this.errors.typeaccountowner">
              <b>لطفا حروف وارد کنید</b>
            </p>
            <label class="label">شماره شبا (24رقمی)<img :src="star" /></label>
            
            <input
              id="SHEBA"
              class="form-control shebainput"
              type="text"
              v-model="financial.sheba"
              @input="SetComma()"
              :disabled="this.isDisable"
            />
            <p class="error">
              مسئولیت صحت شماره شبا بعهده شما میباشد. لطفا نهایت دقت را لحاظ
              بفرمائید
            </p>
            <p class="error" v-if="this.errors.SHEBA">
              <b>لطفا شماره شبارا وارد کنید</b>
            </p>
            <p class="error" v-if="this.errors.shebalength">
              <b>لطفا 24 رقم وارد نمایید</b>
            </p>
          </div>
          <div class="form-group mt-3">
            <label class="label">توضیحات</label>
            <textarea
              class="form-control"
              v-model="financial.description"
            ></textarea>
          </div>
        </div>
        <div class="text-center" style="margin-top: 20px">
          <button type="submit" class="btnsend">ثبت تغییرات</button>
        </div>
      </form>
    </div>
  </section>
</template>
<script>
import star from "../assets/img/star.png";
import { GetBanks, UpdateBank, GetBankInfo, GetDivid2 } from "@/API/API";
import Select2 from "vue3-select2-component";
export default {
  name: "Identity",
  components: { Select2 },
  data() {
    return {
      isDisable: false,
      star,
      banks: {},
      price: 0,
      errors: {
        bankname: "",
        BankAccountNumber: "",
        BankAccountOwnerName: "",
        typeaccountowner: "",
        SHEBA: "",
        shebalength: "",
        length: 0,
      },
      financial: {},
      divid: 0,
    };
  },
  async created() {
    this.financial = (await GetBankInfo(this.$store.getters.seq)).data.result;
    this.divid = (await GetDivid2(this.$store.getters.seq)).data.result;
    if (this.divid < 2 || this.financial.sheba == null) {
      this.isDisable = false;
    }
    console.log(this.isDisable)
    this.banks = (await GetBanks()).data.result;
  },
  methods: {
    validateNumber: (event) => {
      let keyCode = event.keyCode;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
    changeBankItem({ id }) {
      this.financial.bankID = id;
    },
    checkForm: function (e) {
      e.preventDefault();
      this.errors = [];
      if (this.financial.bankID == 0) {
        this.errors.bankname = true;
        this.errors.length += 1;
      }
      if (!this.financial.bankAccountNumber) {
        this.errors.BankAccountNumber = true;
        this.errors.length += 1;
      }
      if (!this.financial.bankAccountOwnerName) {
        this.errors.BankAccountOwnerName = true;
        this.errors.length += 1;
      }
      if (/\d/.test(this.financial.bankAccountOwnerName)) {
        this.errors.typeaccountowner = true;
        this.errors.length += 1;
      }
      if (!this.financial.sheba) {
        this.errors.SHEBA = true;
        this.errors.length += 1;
      }
      if (this.financial.sheba) {
        let finalsheba = this.financial.sheba.replace(/\s/g, "");
        if (
          finalsheba.toString().length != 24 &&
          finalsheba.toString().length != 0
        ) {
          this.errors.shebalength = true;
          this.errors.length += 1;
        }
      }
      if (this.errors.length == 0) {
        this.financial.bankID = parseInt(this.financial.bankID);
        UpdateBank(this.financial).then((resp) => {
          if (resp.data.statusCode == 404) {
            this.$swal({
              icon: "error",
              title: "خطا",
              text: "شماره شبا تکراری است",
              confirmButtonColor: "#900C3F",
              confirmButtonText: "باشه",
            });
          } else if (resp.data.statusCode == 200) {
            this.$swal({
              icon: "success",
              title: "موفق",
              text: "ویرایش با موفقیت انجام شد",
              confirmButtonColor: "#1e682d",
              confirmButtonText: "باشه",
            });
          } else {
            this.$swal({
              icon: "success",
              title: "موفق",
              text: "عملیات با شکست مواجه شد",
              confirmButtonColor: "#1e682d",
              confirmButtonText: "باشه",
            });
          }
        });
      }
    },
    SetComma() {
      const count = document.getElementsByClassName("shebainput");
      for (let i = 0; i <= count.length; i++) {
        let x = document.querySelector("#SHEBA").value;
        console.log(x);
        let y = x.replace(/\s/g, "");
        console.log(y);
        if (!(!isNaN(y) && isFinite(y) && !/e/i.test(y))) {
          this.$swal({
            icon: "error",
            title: "خطا",
            text: "لطفاعدد وارد نمایید",
            confirmButtonColor: "#900C3F",
            confirmButtonText: "باشه",
          });
          document.querySelector("#SHEBA").value = "";
        } else {
          document.querySelector("#SHEBA").value = x.replace(
            /(\d{4}(?!\s))/g,
            "$1 "
          );
        }
      }
    },
  },
};
</script>
<style scoped>
input#SHEBA {
  text-align: center;
  direction: ltr;
}
.section-title h2 {
  font-size: 18px;
  font-weight: 700;
  padding: 0;
  line-height: 18px;
  margin: 30px 0 20px 0;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #111;
  font-family: "iransans", Lato, sans-serif;
  padding-bottom: 15px;
  position: relative;
}
.section-title h2::after {
  content: "";
  width: 190px;
  height: 2px;
  background: #d1a44f;
  bottom: 0;
  top: auto;
  position: absolute;
  right: 0;
}
.error {
  color: #dd3e3e;
  text-align: right;
  font-weight: bold;
}
</style>
